import { PERIOD_SORT } from "library/SFG20/constants.mjs"
export function periodIntervalHoursFromTask(task, timeLookup = PERIOD_SORT) {
    if (task.intervalInHours) return task.intervalInHours
    return (task.intervalInHours = +(
        (timeLookup[task.frequency?.period] ?? 0) * (task.frequency?.interval || 1)
    ).toFixed(0))
}
export function calculatePeriodIntervalHoursFrom(task, timeLookup = PERIOD_SORT) {
    return +((timeLookup[task.frequency?.period] ?? 0) * (task.frequency?.interval || 1)).toFixed(0)
}
